import React, {useEffect} from 'react';
import {FederatedButton, Icon, Label} from 'app/components/authProvider/buttons/sharedStyles';
import {COLORS} from '@fupa/fupa-uikit';
import {useNative} from 'app/contexts/NativeContext';
import FederatedProviderPlaceholder from 'app/components/authProvider/buttons/FederatedProviderPlaceholder';

export default function AppleButton({onClick, initialized, onInitialized}) {
  const [show, setShow] = React.useState(false);
  const {platform, isFlutter} = useNative();

  useEffect(() => {
    if (!(platform === 'android' && isFlutter)) {
      setShow(true);
    }
    onInitialized();
  }, [platform, isFlutter]);

  if (!initialized || !show) {
    return <FederatedProviderPlaceholder />;
  }

  return (
    <FederatedButton tabIndex='1' onClick={onClick} color='black'>
      <Icon src='apple-logo-white.svg' width={20} height={20} alt='apple' />
      <Label color={COLORS.white}>Mit Apple fortfahren</Label>
    </FederatedButton>
  );
}
